import _Vue from "vue"
import { navigationService } from "vue-spatialnavigation";

class FocusPlugin {
  public install(Vue: typeof _Vue) {

    Vue.directive('focus-on-insert', {
        // When the bound element is inserted into the DOM...
        inserted: function (divElement, binding) {

          // Passing no value focuses unconditionally, as before. Passing one
          // treats it as a condition — Vue 2 cannot apply a directive
          // conditionally in a template, so inside a v-for this is how you
          // focus only one item, e.g. v-focus-on-insert="index === 0".
          if (binding.value !== undefined && !binding.value) return;

          // Focus the element
          setTimeout(() => {
            const el = navigationService.getFocusElementById(divElement.id);
            if (el) {
              el.focus();
              // eslint-disable-next-line
              // @ts-ignore
              document.getElementById(el.id).focus();
            }
          }, 100);
      
        }
    })
  }
}

export default new FocusPlugin() ;
